import * as React from "react"
import withStyles, {WithStyles, StyleRules, ClassNameMap} from "@material-ui/core/styles/withStyles"
import {Theme} from "@material-ui/core/styles"
import PortalUserContext, { UserType } from "../lib/portal-user-context"

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
    textAlign: "center",
    marginTop: 50
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  requireUserType?: UserType 
  requireOneOfFeatures?: Array<string> 
  silent?: boolean
}

type State = {}

class Require extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}
  }

  // componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

  render() {
    const { requireUserType, requireOneOfFeatures, silent} = this.props

    let isAuthorized = PortalUserContext.isLoggedIn()

    if(isAuthorized && requireUserType) {
      isAuthorized = PortalUserContext.isUserOfType(requireUserType)
    }

    if(isAuthorized && requireOneOfFeatures) {
      isAuthorized = PortalUserContext.hasOneOfFeatures(requireOneOfFeatures)
    }
    const {classes}: {classes: ClassNameMap} = this.props

    if(!isAuthorized) {
        if(silent) {
            return null 
        } else {
            return (
                <div className={classes.container}>
                You are not authorized to access this feature
                </div>
            )
        }
    } else {
      return this.props.children
    }
  }
}

export default withStyles(styles)(Require)

